<!-- <template>
    <div class="software-integrations-area bg-gradient-color new-padding">
        <div class="container">
            <div class="row align-items-center direction-mob">
                <div class="col-lg-6 col-md-12">
                    <div class="software-integrations-content white-color">
                        <span class="sub-title text-uppercase  ">Our Edge</span>
                        <h2>What Sets Us Apart</h2>
                        <p>We’re not just developers—we’re storytellers, strategists, and technologists combined. From
                            MEAN, MERN, MEVN to Python frameworks like Django and Flask, plus a mastery of cloud
                            platforms (AWS), our stack is built for scalability, speed, and results.</p>
                        <p>We also hold industry-recognized achievements that validate our quality and innovation:</p>
                        <p><strong>ISO 20000-1:2018 Certification</strong> for IT Service Management - proof of our
                            commitment </p>
                        <p><strong>NASSCOM Best Product Shortlist (2019)</strong> recognized among India’s most
                            innovative tech solutions.</p>
                        <p><strong>Emerging Technology Partner (2021)</strong> awarded for driving transformative
                            solutions in cutting-edge domains.
                        </p>

                        <router-link to="/contact" class="default-btn">Contact Us</router-link>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="software-integrations-list">
                        <img src="../../assets/images/shape/border.png" alt="border">
                        <ul>
                            <li data-aos="fade-down">
                                <img src="../../assets/images/software-integrations/atlassian.png" class="atlassian"
                                    alt="atlassian">
                            </li>
                            <li data-aos="fade-right">
                                <img src="../../assets/images/software-integrations/skype.png" class="skype"
                                    alt="skype">
                            </li>
                            <li data-aos="fade-up">
                                <img src="../../assets/images/software-integrations/gdrive.png" class="gdrive"
                                    alt="gdrive">
                            </li>
                            <li data-aos="fade-down">
                                <img src="../../assets/images/software-integrations/slack.png" class="slack"
                                    alt="slack">
                            </li>
                            <li data-aos="fade-up">
                                <img src="../../assets/images/software-integrations/jira.png" class="jira" alt="jira">
                            </li>
                            <li>
                                <img src="../../assets/images/software-integrations/frame.png" class="frame"
                                    alt="frame">
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="shape8">
            <img src="../../assets/images/shape/shape7.png" alt="shape">
        </div>
    </div>




   


</template>

<style>
.mobile-app-area {
    padding: 50px 0px 0px;
}

.new-padding {
    padding: 40px 0px;
}


@media screen and (max-width: 767px) {
    .direction-mob p {
    text-align: center;
}
}
</style>
<script>
export default {
    name: 'ChallengesAndTrack',
    methods: {
      openCalendly() {
     // eslint-disable-next-line no-undef
      Calendly.initPopupWidget({url:'https://calendly.com/connect-to-meander/30min'});
return false;
    }
  }
}
</script> -->



<template>
    <div class="app-progress-area bg-black mt-5">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="app-progress-animation-image" :style="{ paddingBottom: '0px' }"> 
                        <img src="../../assets/images/app-progress/section10.png" alt="app-progress" data-aos="fade-down" >
                       
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="app-progress-content text-white">
                        <span class="sub-title text-uppercase  ">#Technology Excellence</span>
                        <h2>Your Vision, Our Expertise </h2>
                        <p>We stand out not just for what we offer, but for how we deliver it. With a proven track record across 10+ industries, we follow an agile development process to create scalable, future-ready tech solutions. Our certified and experienced team ensures transparent pricing, clear communication, and dedicated post-launch support, turning your vision into reality with precision and care.
                        </p>
                        <router-link to="/contact" class="nav-link">  <button   class="default-btn">Contact Us</button>   </router-link>
   
                
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.mobile-app-area {
    padding: 50px 0px 0px;
}
</style>
<script>
export default {
    name: 'ChallengesAndTrack',
    methods: {
      openCalendly() {
     // eslint-disable-next-line no-undef
      Calendly.initPopupWidget({url:'https://calendly.com/connect-to-meander/30min'});
return false;
    }
  }
}
</script>
 
